module.exports = __webpack_public_path__ + "static/media/MarkerFelt-Thin.46110ca4.svg";